import styled, { css } from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'
import { getResponsiveFontSizeCSS } from 'helpers/css'
import { isDesktop } from 'utils/device'

export const Wrapper = styled.div`
    position: relative;
    border-radius: 10px;
`

export const Container = styled.div`
    z-index: 2;
    position: relative;
    border-radius: 10px;
    height: 100%;
    ${isDesktop &&
        css`
            ${FlexCentered}
        `}
    ${!isDesktop &&
        css`
            height: unset;
        `}
`
export const Name = styled.div`
    position: absolute;
    width: 100%;
    height: 55px;
    z-index: 10;
    left: 0;
    bottom: -1px;
    color: #fff;
    font-family: Avenir;
    font-weight: 800;
    font-size: ${getResponsiveFontSizeCSS(12, 18)};
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    background: rgb(2, 0, 36);
    background: linear-gradient(
        360deg,
        rgba(0, 0, 0, 0.8) 0%,
        rgba(0, 0, 0, 0) 70%
    );
    padding-top: 26px;
    padding-left: 22px;
    cursor: default;
    @media only screen and (max-width: 992px) {
        height: 35px;
        padding-top: 16px;
    }
`
